/*
 * ******************************************************************
 * Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: 'summary-grid-total',
    templateUrl: './summary-grid-total.component.html',
    styleUrls: ['./summary-grid-total.component.scss']
})
// @formatter:on
export class SummaryGridTotalComponent {
}
